// Update Lookbook Order Item
export const UPDATE_LOOKBOOK_ORDER_ITEM_REQUEST = 'UPDATE_LOOKBOOK_ORDER_ITEM_REQUEST';
export const UPDATE_LOOKBOOK_ORDER_ITEM_DONE = 'UPDATE_LOOKBOOK_ORDER_ITEM_DONE';
export const UPDATE_LOOKBOOK_ORDER_ITEM_FAILED = 'UPDATE_LOOKBOOK_ORDER_ITEM_FAILED';
export const UPDATE_LOOKBOOK_ORDER_ITEM_CLEAR_ERRORS = 'UPDATE_LOOKBOOK_ORDER_ITEM_CLEAR_ERRORS';
export const UPDATE_LOOKBOOK_ORDER_ITEM_RESET = 'UPDATE_LOOKBOOK_ORDER_ITEM_RESET';